// extracted by mini-css-extract-plugin
export default {"ad_sync_banner":"styles__ad_sync_banner___jWg64"};